module.exports = __webpack_public_path__ + "img/lounge_e2c9e08.webp";